import Tooltip from "@mui/material/Tooltip";
import React from "react";
import { CustomTooltipProps } from "../interface/CustomTooltipInterface";

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  title,
  children,
  placement = "top",
}) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow
      PopperProps={{
        modifiers: [
          {
            name: "preventOverflow",
            options: {
              boundary: "window",
            },
          },
        ],
      }}
      componentsProps={{
        tooltip: {
          sx: {
            background: "#202020E5",
            color: "#ffffff", // ✅ Fixed typo (was #fffff)
            fontSize: "12px",
            fontWeight: "400",
            padding: "4px",
            borderRadius: "4px",
            fontFamily: "Mazzard",
          },
        },
        arrow: {
          sx: {
            color: "#202020E5",
          },
        },
      }}
    >
      {React.isValidElement(children) ? children : <span>{children}</span>}
    </Tooltip>
  );
};

export default CustomTooltip;
